import { render } from "./ElektroonilineValveLeht.vue?vue&type=template&id=5d8bc7c8&ts=true"
import script from "./ElektroonilineValveLeht.vue?vue&type=script&lang=ts"
export * from "./ElektroonilineValveLeht.vue?vue&type=script&lang=ts"

import "./ElektroonilineValveLeht.vue?vue&type=style&index=0&id=5d8bc7c8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__